@if (isPopup) {
  <!-- ConfirmPopup arrow; the side class on the host points it at the anchor -->
  <span class="am-arrow" aria-hidden="true"></span>
}
@if (title || showClose) {
  <div class="am-header" [class.am-header-bare]="!title">
    <h5 class="am-title">{{ title }}</h5>
    @if (showClose) {
      <button type="button" class="am-close" aria-label="Close" data-testid="app-modal-close"
              (click)="ref.dismiss('close-x')">
        <span aria-hidden="true">&times;</span>
      </button>
    }
  </div>
}
<div class="am-body">
  <ng-container #contentHost></ng-container>
  @if (templateContent) {
    <ng-container [ngTemplateOutlet]="templateContent" [ngTemplateOutletContext]="templateContext"></ng-container>
  }
</div>
@if (buttons.length) {
  <div class="am-footer" data-testid="app-modal-footer">
    @for (button of buttons; track button.label) {
      <button type="button" [class]="buttonClass(button)" [attr.title]="hotkeyTip(button)"
              (click)="onButton(button)">
        {{ button.label }}
        @if (button.hotkey) {
          <kbd class="am-kbd">{{ hotkeyLabel(button) }}</kbd>
        }
      </button>
    }
  </div>
}
